import { render, staticRenderFns } from "./UserRoleEditForm.vue?vue&type=template&id=6db9d8e7&scoped=true&"
import script from "./UserRoleEditForm.vue?vue&type=script&lang=js&"
export * from "./UserRoleEditForm.vue?vue&type=script&lang=js&"
import style0 from "./UserRoleEditForm.vue?vue&type=style&index=0&id=6db9d8e7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db9d8e7",
  null
  
)

export default component.exports